/**
 * API configuration utility
 * Centralizes API base URL configuration
 */

// Get API base URL from environment variable or use default
const getApiBaseUrl = () => {
  // Use environment variable if set (for Vercel or custom config)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Production: use relative path (Vercel rewrites handle routing to api.fastandslow.ai)
  // This ensures same-domain cookies work (browser sees www.fastandslow.ai, not api.fastandslow.ai)
  if (process.env.NODE_ENV === 'production') {
    return '';  // Relative path - Vercel rewrites proxy to api.fastandslow.ai
  }
  
  // Development: use relative path (proxy in package.json handles it)
  return '';
};

export const API_BASE_URL = getApiBaseUrl();

/**
 * Build full API URL
 * @param {string} endpoint - API endpoint (e.g., '/api/modules')
 * @returns {string} Full API URL
 */
export const buildApiUrl = (endpoint) => {
  // Remove leading slash if present (we'll add it)
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  
  if (API_BASE_URL) {
    // Production: use full URL
    return `${API_BASE_URL}${cleanEndpoint}`;
  }
  
  // Development: use relative path (proxy handles it)
  return cleanEndpoint;
};

